import { render, staticRenderFns } from "./ArticleCategory.vue?vue&type=template&id=638f0d6e&scoped=true&"
import script from "./ArticleCategory.vue?vue&type=script&lang=js&"
export * from "./ArticleCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638f0d6e",
  null
  
)

export default component.exports